<template>
    <div v-if="amountPages > 1"  class="pagination-wrapper">
        <button @click="onClickPreviousPage" :disabled="isInFirstPage">&lt;</button>
        <button
            v-for="item in this.pageList"
            v-bind:key="item"
            :class="{ active: item == this.currentPage }"
            :disabled="item == this.currentPage"
            @click="onClickPage(item)"
        >
            {{ item }}
        </button>
        <button @click="onClickNextPage" :disabled="isInLastPage">></button>
    </div>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
        currentPage: {
            type: Number,
            required: true,
        },
        totalPages: {
            type: Number,
            required: true,
        },
        perPage: {
            type: Number,
            default: 10,
        },
    },
    data() {
        return { pageList: [] };
    },
    methods: {
        constructPageList() {
            for (let i = 0; i < (this.totalPages / this.perPage); i++) this.pageList.push(i + 1);
        },
        onClickPreviousPage() {
            this.$emit('pagechanged', this.currentPage - 1);
        },
        onClickPage(page) {
            this.$emit('pagechanged', page);
        },
        onClickNextPage() {
            this.$emit('pagechanged', this.currentPage + 1);
        },
    },

    mounted() {
        this.constructPageList();
    },
    computed: {
        isInFirstPage() {
            return this.currentPage === 1;
        },
        isInLastPage() {
            return this.currentPage === this.totalPages;
        },
        amountPages(){
            return (this.totalPages / this.perPage)
        }
    },
};
</script>

<style lang="scss" scoped>
.pagination-wrapper {
    display: block;
    float: right;
}

.pagination-wrapper button {
    color: black;
    float: left;
    padding: 8px 16px;
    text-decoration: none;
    background-color: $gray-300;
    transition: background-color 0.3s;
    border: 1px solid $gray-500;
}

.pagination-wrapper button.active {
    background-color: #004677;
    color: white;
}

.pagination-wrapper button:hover:not(.active) {
    background-color: $gray-100;
}
</style>
